import http from "../http-common";
import authHeader from "./authHeader";
import { FIN_API } from "../api";
const getAllFin = () => {
  return http.get(`${FIN_API}`);
};
const getAllFinOfEmployee = (id) => {
  return http.get(`${FIN_API}/emp/${id}`, { headers: authHeader() });
};

// const getRoleById = (id) => {
//   return http.get(`${FIN_API}/${id}`, { headers: authHeader() });
// };

const createFin = (data) => {
  return http.post(`${FIN_API}`, data, { headers: authHeader() });
};
// const resignRole = (id) => {
//   return http.put(`${FIN_API}/${id}`, { role: null }, { headers: authHeader() });
// };
// const updateRole = (id, data) => {
//   return http.put(`${FIN_API}/${id}`, data, { headers: authHeader() });
// };

// const removeRole = (id) => {
//   return http.delete(`${FIN_API}/${id}`, { headers: authHeader() });
// };

const FinService = {
  getAllFin,
  getAllFinOfEmployee,
  // getRoleById,
  createFin,
  // updateRole,
  // removeRole,
  // resignRole,
};

export default FinService;
